import axios from 'axios';
import React from 'react';
import { supabase } from './supabaseClient';
import './App.css';

const array = [
  {label: 'いつ', value: 'when', example: 'ある日', yobun: '', maxLength: 10},
  {label: 'どこで', value: 'where', example: '公園', yobun: 'で', maxLength: 10},
  {label: '誰が', value: 'who', example: '帽子をかぶった人', yobun: 'が', maxLength: 10},
  {label: '何をした', value: 'what', example: 'スクワットをした', yobun: '', maxLength: 10}
];

class Main extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: array[Math.floor(Math.random() * array.length)],
      input: '',
      isSubmit: false,
      japanese: '',
      english: '',
      isLoading: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit      = this.handleSubmit.bind(this);
    this.handleRestart     = this.handleRestart.bind(this);
  }

  async getText() {
    const randomId = Math.floor( Math.random() * 200 ) + 1;
    let { data: Texts, error } = await supabase.from('Sentences').select("*").eq('id', randomId);

    if (error) {
      // TODO: エラーを画面に表示
      console.log(error);
    } else {
      return Texts[0];
    }
  }

  async translateText(text) {
    const response = await axios.request({
      url: process.env.REACT_APP_CLOUD_FUNCTIONS_URL,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': "*"
      },
      data: {
        text: text
      }
    });

    return response['data'];
  }

  handleInputChange(event) {
    this.setState({
      input: event.target.value
    });
  }

  handleSubmit(event) {
    this.setState({
      isLoading: true
    });

    this.getText().then((text) => {
      text[this.state.data['value']] = this.state.input;

      const japanese = text['when'] + ' ' + text['where'] + 'で ' + text['who'] + 'が ' + text['what'];

      this.translateText(japanese).then((value) => {
        this.setState({
          isSubmit: true,
          japanese: japanese,
          english: value
        });
      });
    });

    event.preventDefault();
  }

  handleRestart(event) {
    this.setState({
      data: array[Math.floor(Math.random() * array.length)],
      input: '',
      isSubmit: false,
      japanese: '',
      english: '',
      isLoading: false
    });
    event.preventDefault();
  }

  render() {
    if(!this.state.isSubmit) {
      return (
        <Form
          data={this.state.data}
          input={this.state.input}
          onInputChange={this.handleInputChange}
          onSubmit={this.handleSubmit}
          isLoading={this.state.isLoading} />
      );
    } else {
      return (
        <Result
          japanese={this.state.japanese}
          english={this.state.english}
          onRestart={this.handleRestart} />
      )
    }
  }
}

class Form extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit      = this.handleSubmit.bind(this);
  }

  handleInputChange(event) {
    this.props.onInputChange(event);
  }

  handleSubmit(event) {
    this.props.onSubmit(event);
  }

  render() {
    const data      = this.props.data;
    const input     = this.props.input;
    const isLoading = this.props.isLoading;

    return (
      <div className="app">
        <img src="../top.png" alt="" className="top-image"/>
        <form onSubmit={this.handleSubmit}>
          <p>あなたの担当は「{data['label']}」です</p>
          <div className="input-form">
            <input
              className={data['yobun'] ? "yobun-space" : ''}
              name="text"
              type="text"
              placeholder={data['example']}
              value={input}
              onChange={this.handleInputChange}
              autoFocus={true} />{data['yobun']}
          </div>
          <div className={input.length > data['maxLength'] ? "warning small" : "small"}>{input.length} / {data['maxLength']}文字</div>
          <button className="btn btn-normal" type="submit" disabled={input.length === 0 || input.length > data['maxLength']}>{!isLoading ? '文章を作って翻訳' : <div className="loader"></div>}</button>
        </form>
      </div>
    );
  }
}

class Result extends React.Component {
  constructor(props) {
    super(props);

    this.handleRestart = this.handleRestart.bind(this);
  }

  handleRestart(event) {
    this.props.onRestart(event);
  }

  render() {
    const japanese = this.props.japanese.replaceAll(" ", "");
    const english  = this.props.english;
    const url = "https://twitter.com/share?url=https://4w-english.vercel.app&text=" + english + "%0a%0a" + japanese + "%0a%20%23この英語どこで使うの";

    return (
      <div className="app">
        <div className="results">
          <p>{english}</p>
          <p>{japanese}</p>
        </div>
        <div>
          <a className="btn btn-share" href={url}>Twitterでシェア</a>
        </div>
        <button className="btn btn-repeat" onClick={this.handleRestart}>もう一度</button>
        <div style={{marginTop: "20px", textAlign: "center"}}>
          <a href="https://translate.google.com/" target="_blank" rel="noreferrer"><img src="../google_translate.png" alt="powered by Google Translate" style={{width: "200px"}}></img></a>
        </div>
      </div>
    );
  }
}

function App() {
  return (
    <Main />
  );
}

export default App;
